export default __webpack_public_path__ + "static/media/projects.05e0bda1.svg";